<app-top-header></app-top-header>
<app-header></app-header>
<div class="main">
  <div class="top-background"></div>
  <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
<app-footer-large></app-footer-large>
<div style="display: none">
  <app-home [video]="false"></app-home>
</div>
